module.exports = __webpack_public_path__ + "static/media/011.59aa7637.jpg";